export default __webpack_public_path__ + "static/media/firefox-icon.75267af1.png";